import { AnalyticsItem } from '../AnalyticManager';
import { PurchaseEventParameters } from '../types';

declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
  }
}

class GoogleTagManagerDataLayer implements AnalyticsItem {
  init(): void {}

  trackEvent(): void {}

  trackPurchase(_eventName: string, parameters: PurchaseEventParameters): void {
    if (!window.dataLayer) return;

    window.dataLayer.push({
      event: 'purchase',
      currency: parameters.currency || 'USD',
      value: parameters.value,
      transaction_id: parameters.order_id,
      email: parameters.email || '',
      locale: parameters.locale || '',
      subscription_type: parameters.subscription_type || '',
    });
  }

  trackRegistration(): void {
    if (!window.dataLayer) return;

    window.dataLayer.push({ event: 'registration' });
  }
}

export default GoogleTagManagerDataLayer;
